import { getEnvUrl,getToken,axiosInstance } from "../../utils/Api";
 
    export const createSubject = async (formdata) =>{ 
    try {
        const response = await axiosInstance.post("/admin/subject/addGameSubject",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 
    export const updateSubject = async (formdata) =>{ 
    try {
        const response = await axiosInstance.put("/admin/subject/updateSubject",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 

export const getSubjectByID = async (subjectId) => {
  try {
    const response = await axiosInstance.get(`/admin/subject/getSubject`, {
      params: { id: subjectId }, 
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error in getSubjectByID:', error);
    return false;
  }
};



export const deleteSubjectByID = async (deleteSubjectID) => {
  try {
     const response = await axiosInstance.delete(`/admin/subject/deleteSubject`,{     
            data:{game_subject_id:deleteSubjectID},
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
      });
      return response.data;
    } catch (error) {
         console.error('Error in delete Subject:', error);
        return false;
    }
};

export const getSubjects = async () =>{ 
    try {
        const response = await axiosInstance.get("/subject/list",{
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
}
 
 